import { render, staticRenderFns } from "./ModalProcesso.vue?vue&type=template&id=671752ef&scoped=true&"
import script from "./ModalProcesso.vue?vue&type=script&lang=js&"
export * from "./ModalProcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671752ef",
  null
  
)

export default component.exports